import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/subConsortiums', request, cancelToken)
}

export {get}
